import { render } from "./createRoute.vue?vue&type=template&id=deb61388"
import script from "./createRoute.vue?vue&type=script&lang=js"
export * from "./createRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__